export const init = () => {

  // TRACKER 'HOMEPAGE'
  const sep = AnalyticsConstants.concatenator;
  const fwk = CUBE.Analytics;
  const utils = fwk.utils.homepage;

  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.homepage.homepage);

  // - PUSH PRODUCT
  const hpPushProduct = new AnalyticsTriggerEvent('hpPushProduct', tracker.defaultEvent());
  hpPushProduct.trigger = 'mouseup.st';
  hpPushProduct.domContainer = '#main-container';
  hpPushProduct.domElement = 'article.dkt-product a';
  hpPushProduct.options.action = 'HPPushProduct';
  hpPushProduct.stopEvent = ($element, data, jqEvent) => jqEvent.which === 3;
  hpPushProduct.getLabel = ($element) => {
    const product = $element.closest('article');
    const productAll = product.closest('.list-products').find('article');

    let label = `Floor-${  utils.getFloorIndex($element)  }${sep}`;
    label += `Position-${  productAll.index(product)+1  }${sep}`;
    label += product.find('.dkt-product__title').text().trim();

    return label;
  };
  hpPushProduct.getValue = ($element) => {
    let price = $element.closest('article').find('[itemprop="price"]').text().trim().replace(',', '.');
    // eslint-disable-next-line no-useless-escape
    price = Number(price.replace(/[^0-9\.-]+/g,''));
    return parseInt(price,10);
  };
  tracker.addEvent(hpPushProduct);

  // - BRANDS
  const eventBrands = new AnalyticsSlickEvent('hpBrands', tracker.defaultEvent());

  eventBrands.domContainer = '.slick-brands';
  eventBrands.domElement = '.brand-block';
  eventBrands.options.action = 'HPBrands';

  eventBrands.trackDots();
  eventBrands.trackArrows();
  eventBrands.trackElements({
    getLabel($element, _indexElement, _indexFloor) {
	    	let brandName = 'unknown';
	    	const searchedClass = 'sprite-brand-large-';
      const brandClass = $.grep($element.find('a div').attr('class').split(' '), (v, i) => v.indexOf(searchedClass) === 0).join();
      if (brandClass !== null)
        brandName = brandClass.replace(searchedClass, '');
      return AnalyticsConstants.slick.defaultValuePosition +  _indexElement + AnalyticsConstants.concatenator + brandName;
    }
  });

  tracker.addEvent(eventBrands);

  // - RECALLS
  const eventRecall = new AnalyticsSlickEvent('hpRecall', tracker.defaultEvent());

  eventRecall.domContainer = '.slick-informations';
  eventRecall.domElement = 'div.information a';
  eventRecall.options.action = 'HPRecall';

  eventRecall.trackDots();
  eventRecall.trackArrows();
  eventRecall.trackElements({
    vars: {
      selectorParent: '.row',
      selectorTarget: 'div.desc strong',
    },
    getLabel($element, _indexElement, _indexFloor) {
	    	// Recall's name is display in the strong tag of the element.
	    	const recallName = 'unknown';
	    	let searchedElement = $element.closest(this.vars.selectorParent).find(this.vars.selectorTarget).first();
	    	if (searchedElement !== null)
        searchedElement = searchedElement.text();
      return AnalyticsConstants.slick.defaultValuePosition +  _indexElement + AnalyticsConstants.concatenator + searchedElement;
    }
  });

  tracker.addEvent(eventRecall);

  // HP BANNER - FLOOR OPECO - NAVIGATION
  const eventHPBanner_Nav = new AnalyticsEvent('eventHPBanner_Nav', tracker.defaultEvent());
  eventHPBanner_Nav.options.action = 'HPBanner';
  cube.event.on('slider-hp-opeco', (current) => {
    eventHPBanner_Nav.options.label = `Pagination-${  current+1}`;
    eventHPBanner_Nav.send();
  });

  // HP BANNER - FLOOR OPECO - CLICK
  const eventHPBanner_Click = new AnalyticsClickEvent('eventHPBanner_Click', tracker.defaultEvent());
  eventHPBanner_Click.domContainer = 'div.dkt-home-slider';
  eventHPBanner_Click.domElement = 'li.dkt-home-slider__slide';
  eventHPBanner_Click.options.action = 'HPBanner';
  eventHPBanner_Click.getLabel = ($element) => {
    // Get URL parameters to find opeco, intcmp ...
    const paramsURL = ($element.find('a').attr('href').split('?')[1] || '').split('&');
    let operationType;
    let operationName;
    // Get operation type (opeco, intcmp...) and name
    paramsURL.forEach((e) => {
      if (e.indexOf('type=') > -1) {
        [operationType] = e.split('=');
      }
    });
    paramsURL.forEach((e) => {
      if (e.indexOf(`${operationType}=`) > -1) {
        [operationType] = e.split('=');
      }
    });

    if (operationName.indexOf(`${operationType}:`) > -1) {
      [operationName] = operationName.split(`${operationType}:`);
    }

    // Get the slide position
    const position = $element.closest('ul').find($element).index() + 1;

    let label = `Position-${position}`;
    if (operationType) label += `|${operationType}`;
    if (operationName) label += `|${operationName}`;

    return label;
  };
  tracker.addEvent(eventHPBanner_Click);


  // - FLOOR BANNER
  const paramsFloorBanner = {
    vars: {
      selectorParent: '.container-fluid',
      selectorClassBig: 'floor-push-opco',
      selectorClassBigCta: 'button-wrapper',
      selectorClassMedium: 'floor-push',
      selectorClassPosition: 'floor-push-reverse',
    },
    getLabel($element, _indexElement, _indexFloor) {
      //  -> 'Floor-X' / '%FLOOR_NAME%' / [ 'Position-{left, right}' ] / '{big, medium[-cta]}'
      let size;
      let position = '';
      const $parent = $element.closest(this.vars.selectorParent);
      let floorName = '';

      if ($parent.hasClass(this.vars.selectorClassBig)) { // OPCO
        size = 'big';
        floorName = $element.closest('div.floor-push-opco').find('a:first').attr('title');
        if ($element.parent().hasClass(this.vars.selectorClassBigCta))
          size += '-cta';
      }
      if ($parent.hasClass(this.vars.selectorClassMedium)) { // LIST-PRODUCTS
        size = 'medium';
        floorName = $element.closest('div.list-products').attr('id');
        if ($parent.hasClass(this.vars.selectorClassPosition))
          position = `${AnalyticsConstants.slick.defaultValuePosition  }left${  AnalyticsConstants.concatenator}`;
        else
          position = `${AnalyticsConstants.slick.defaultValuePosition  }right${  AnalyticsConstants.concatenator}`;
      }
      return AnalyticsConstants.slick.defaultValueFloor + _indexFloor + AnalyticsConstants.concatenator + floorName + AnalyticsConstants.concatenator + position + size;

    }
  };
  // + (inside floor)
  const eventFloorsBannerInsideFloor = new AnalyticsSlickEvent('hpFloorsBannerInside', tracker.defaultEvent());
  eventFloorsBannerInsideFloor.domContainer = '.floor-push';
  eventFloorsBannerInsideFloor.domElement = '.btn-wrapper a';
  eventFloorsBannerInsideFloor.options.action = 'HPBanner';
  eventFloorsBannerInsideFloor.trackElements(paramsFloorBanner);
  tracker.addEvent(eventFloorsBannerInsideFloor);
  // + (banner alone)
  const eventFloorsBannerAlone = new AnalyticsSlickEvent('hpFloorsBannerBig', tracker.defaultEvent());
  eventFloorsBannerAlone.domContainer = '.floor-push-opco';
  eventFloorsBannerAlone.domElement = 'a';
  eventFloorsBannerAlone.options.action = 'HPBanner';
  eventFloorsBannerAlone.trackElements(paramsFloorBanner);
  tracker.addEvent(eventFloorsBannerAlone);

  // - FLOOR NAVIGATION
  const eventFloorNavigation = new AnalyticsTriggerEvent('hpFloorNavigation', tracker.defaultEvent());

  eventFloorNavigation.domContainer = '#block_vertical-nav ul';
  eventFloorNavigation.domElement = 'a';
  eventFloorNavigation.trigger = 'click';
  eventFloorNavigation.options.action = 'HPFloorNavigation';

  eventFloorNavigation.getLabel = function($element) {return  $(this.domContainer).find(this.domElement).index($element) + 1; };

  tracker.addEvent(eventFloorNavigation);

  // - INSURANCES TOP
  const eventInsurancesTop = new AnalyticsSlickEvent('hpInsurancesTop', tracker.defaultEvent());

  eventInsurancesTop.domContainer = 'nav.services .slick-slider';
  eventInsurancesTop.domElement = '.slick-slide';
  eventInsurancesTop.options.action = 'HPInsurances_top';

  eventInsurancesTop.trackArrows();
  eventInsurancesTop.trackElements({
    vars: {
      selectorElement: 'a',
      selectorAttribute: 'href',
      splitCharacter: '/',
    },
    getLabel($element, _indexElement, _indexFloor) {
	    	// There is no proper way to get the real insurance's name directly.
	    	// We get the link of the element, and keep the last part (after the last '/'), the only relevant one.
      const arrInsuranceLink = $element.find(this.vars.selectorElement).attr(this.vars.selectorAttribute).split(this.vars.splitCharacter);
      const insuranceName = arrInsuranceLink[arrInsuranceLink.length - 1];
      return AnalyticsConstants.slick.defaultValuePosition +  _indexElement + AnalyticsConstants.concatenator + insuranceName;
    }
  });

  tracker.addEvent(eventInsurancesTop);

  // - INSURANCES BOTTOM
  const eventInsurancesBottom = new AnalyticsSlickEvent('hpInsurancesBottom', tracker.defaultEvent());

  eventInsurancesBottom.domContainer = '.slick-services.slick-slider';
  eventInsurancesBottom.domElement = '.slick-slide';
  eventInsurancesBottom.options.action = 'HPInsurances_bottom';

  eventInsurancesBottom.trackArrows();
  eventInsurancesBottom.trackElements({
    vars: {
      selectorElement: 'a',
      selectorAttribute: 'href',
      splitCharacter: '/',
    },
    getLabel($element, _indexElement, _indexFloor) {
	    	// There is no proper way to get the real insurance's name directly.
	    	// We get the link of the element, and keep the last part (after the last '/'), the only relevant one.
      const arrInsuranceLink = $element.find(this.vars.selectorElement).attr(this.vars.selectorAttribute).split(this.vars.splitCharacter);
      const insuranceName = arrInsuranceLink[arrInsuranceLink.length - 1];
      return AnalyticsConstants.slick.defaultValuePosition +  _indexElement + AnalyticsConstants.concatenator + insuranceName;
    }
  });

  tracker.addEvent(eventInsurancesBottom);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};




// WEBPACK FOOTER //
// ./src/analytics/trackers/homepage/home-tracker.js